module.exports = __webpack_public_path__ + "static/img/guantang_banner_bg.3e9e4ec.png";